import { ChallengeResult, closeChallengeDialog } from '../../../modules/challenge';
import { CircularProgress, TextField, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { ChangeEvent, Component, FormEvent, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { authenticate as soapAuthenticate, challenge as soapChallenge } from '../../../modules/api';

import Button from '@material-ui/core/Button';
import ChallengeRequestProps from './ChallengeRequestProps';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  progress: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.main,
  },
})

type State = {
  loading: boolean
  question: {
    questionText: string
    questionId: string
  }
  userAnswer: string
  error: string
};

class QuestionsChallengeRequest extends Component<Props, State> {
  state: State = {
    loading: true,
    question: {
      questionText: "",
      questionId: "",
    },
    userAnswer: "",
    error: "",
  }

  componentWillMount() {
    let args = {
      credentialChallengeRequestList: {
        challengeQuestionChallengeRequest: {
          payload: {
            numberOfQuestion: "1"
          }
        }
      }
    }

    this.props.soapChallenge(args).then((data: any) => {
      try {
        let payload = data.credentialChallengeList.challengeQuestionChallenge.payload

        if (payload.callStatus.statusCode !== "SUCCESS")
          throw new Error("Status code error: " + payload.callStatus.statusCode)

        let question = payload.challengeQuestions.challengeQuestion

        this.setState({
          loading: false,
          question
        })
      } catch (error) {
        console.error(error)
        this.setState({ error: "Failed to retrieve challenge questions" })
      }
    })
  }

  handleAnswerChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({
      userAnswer: e.target.value
    })
  }
  handleAuthenticate = (e: FormEvent) => {
    e.preventDefault()

    const { question, userAnswer } = this.state
    const { questionId } = question
    let args = {
      credentialDataList: {
        challengeQuestionData: {
          payload: {
            challengeQuestion: {
              questionId,
              userAnswer
            }
          }
        }
      }
    }
    this.props.soapAuthenticate(args)
      .then((data: any) => {
        if (data.credentialAuthResultList.challengeQuestionAuthResult.payload.authenticationResult.authStatusCode === "SUCCESS") {
          this.props.challengeResponse(ChallengeResult.Success)
        }
        else {
          this.props.challengeResponse(ChallengeResult.Failure)
        }
      }).catch((error: Error) => {
        this.props.challengeResponse(ChallengeResult.Error)
      })
  }

  handleBack = () => {
    this.props.challengeResponse(ChallengeResult.Pending)
  }

  render() {
    const { loading, question, error } = this.state
    const { classes } = this.props

    return (
      <Fragment>
        {loading &&
          <Fragment>
            <CircularProgress className={classes.progress} />
            {error &&
              <Typography className={classes.error}>{error}</Typography>
            }
          </Fragment>
        }

        {!loading &&
          <Fragment>
            <DialogContent>
              <DialogContentText>
                {error &&
                  <Typography className={classes.error}>{error}</Typography>
                }
                {question.questionText}
              </DialogContentText>
              <form onSubmit={this.handleAuthenticate}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="userAnswer"
                  label="Answer"
                  type="text"
                  onChange={this.handleAnswerChange}
                  fullWidth
                />
              </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleAuthenticate} color="primary">
                Authenticate
              </Button>
              <Button onClick={this.handleBack} color="default">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }
      </Fragment>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge }: IStoreState) => ({
  auth,
  authmethods,
  challenge
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      soapChallenge,
      soapAuthenticate,
      closeChallengeDialog
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ChallengeRequestProps {
  // refer to ChallengeRequestProps.ts
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(QuestionsChallengeRequest));